module.exports = __webpack_public_path__ + "static/media/31_TOP_FRENTE_UNICA_COM_BOJO_LISO_01.3a503ca1.jpg";